import {createApp} from 'vue';
import App from './App.vue';
import router from './router';

createApp(App)
    .use(router)
    .mount('#app');

if ('serviceWorker' in navigator && import.meta.env.PROD) {
    window.addEventListener('load', async () => {
        try {
            const registration = await navigator.serviceWorker.register('./sw.js', {updateViaCache: 'none'});
            await registration.update();
        } catch (error) {
            console.warn('Service Worker registration failed', error);
        }
    });
}
